<template>
  <span v-if="casesWithAttachableLogs.length > 0">
    <v-tooltip bottom>
        <span slot="activator">
          <v-btn icon @click="handleShowForm">
            <slot name="button-content">
              <v-icon>fas fa-file-medical</v-icon>
            </slot>
          </v-btn>
        </span>
       {{title}}
    </v-tooltip>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="showModal">
        <v-card-title class="headline">{{title}}</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            Affected cases: {{casesWithAttachableLogs.length}}
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import _ from 'lodash';
  import {notificationService} from "../../../application";
  import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
  import ModalJsonView from "../../Ui/ModalJsonView";

  function getDefaultFormData() {
    return {}
  }

  export default {
    name: 'batch-attach-logs-to-invoice-form',
    components: {
      ServiceAsBadge,
      ModalJsonView
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      },
      casesWithLog: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        return this.isValid
      },
      casesWithAttachableLogs() {
        return this.casesWithLog
          .map(it => {
            let affectedLogIds = it.affectedServices.list
              .map(it => it.affectedLogRecordIds)
              .reduce((acc, item) => {
                acc.push(...item);
                return acc
              }, []);

            let affectedLogs = affectedLogIds
              .map(logId => {
                let index = _.findIndex(it.log, item => {
                  return item.id === logId
                });
                if (index === -1) {
                  throw Error(`Can't find log by id ${logId}`);
                }
                return it.log[index]
              });


            let attachableLogs = affectedLogs
              .filter(it => {
                if (it.event !== 'ChangeExecuted' || it.metadata.invoiceInfo) {
                  return false
                }

                return true
              });


            return {
              attachableLogs,
              ...it
            }
          })
          .filter(it => {
            return it.attachableLogs.length > 0
          })
      }
    },
    methods: {
      ...mapActions({
        attachLogsToInvoice: 'invoiceAttachBatchLogsToInvoice',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.$refs.form.validate()) {
          return
        }

        let logIds = this.casesWithAttachableLogs.reduce((acc, item) => {
          let itemLogIds = item.attachableLogs.map(it => it.id);
          acc.push(...itemLogIds);
          return acc
        }, []);

        const request = {
          invoiceId: this.invoiceId,
          logIds: logIds
        };

        this.requestInProgress = true;

        this
          .attachLogsToInvoice(request) // add batch action
          .then(() => {
            notificationService.info('Operation success');
            this.resetForm();
            this.requestInProgress = false;
            this.showModal = false
          })
          .catch(e => {
            notificationService.error('Operation failed');
            this.requestInProgress = false;
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/BatchAttachLogsToInvoiceForm.vue